import { map } from "ramda"

import { globalizeSelectors } from "@cirrus/legacy/framework/globalize"
import { lens } from "./lens.es6"

export const getInitialState = () => ({
  byId: {},
  allIds: [],
})

export const getNotifications = (state) => map((id) => state.byId[id], state.allIds)

export default globalizeSelectors(lens, { getNotifications })
